import {dateRangeFilterToAbsoluteDates} from '~/affordance/formatDateRangeFilter';
import {COMPLIANCE_EARLIEST_SELECTABLE_DATE} from '~/affordance/dates/complianceEarliestSelectableDate';
import type {CreativeDateRangeFilter} from '~/report/data/ReportItemDefinitionTypes';
import {isBefore, now} from 'stringdate';

/**
 * Normalises creative date filters for Compliance Explore so URL/state cannot request
 * ranges that start before {@link COMPLIANCE_EARLIEST_SELECTABLE_DATE}.
 * Relative presets that extend earlier are converted to an absolute range.
 */
export function applyComplianceExploreCreativeDateFloor(
    date: CreativeDateRangeFilter | undefined
): CreativeDateRangeFilter | undefined {
    if (!date) return undefined;

    const absolute = dateRangeFilterToAbsoluteDates({
        dateRange: date,
        lastKnownDate: now(),
        overrideAbsoluteEndDateForCurrentMonth: false
    });
    if (!absolute) return date;

    let {startDate, endDate} = absolute;
    if (!isBefore(COMPLIANCE_EARLIEST_SELECTABLE_DATE)(startDate)) {
        return date;
    }

    startDate = COMPLIANCE_EARLIEST_SELECTABLE_DATE;
    if (isBefore(startDate)(endDate)) {
        endDate = now();
    }
    return {absolute: {startDate, endDate}};
}
